export const SUPPLY_METADATA_UPDATED_EVENT = 'supply-metadata-updated';

export const emitSupplyMetadataUpdated = () => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(SUPPLY_METADATA_UPDATED_EVENT, { detail: { at: Date.now() } }));
};
